<script lang="ts">
  import type { Snippet } from 'svelte';
  import Alert from '$shared/atoms/Alert/Alert.svelte';
  import { AlertOption } from '$provider/models/AlertOption';
  import type { AlertDetailedInfo } from '$shared/models/AlertDetailedInfo';
  import GridView from '$shared/organisms/GridView/GridView.svelte';

  interface Props {
    error?: AlertDetailedInfo | string;
    alertSlot?: Snippet | undefined;
    children?: Snippet | undefined;
    onclose?: () => void;
  }

  let { error = '', alertSlot = undefined, children = undefined, onclose }: Props = $props();

  let containerDiv: HTMLDivElement = $state();

  export const scrollIntoView = () => {
    containerDiv?.scrollTo({ top: 0, behavior: 'smooth' });
  };
</script>

<div class="caqh-merge-review-container" bind:this={containerDiv}>
  <GridView>
    {#if error}
      <div class="error">
        <Alert data={error} maxWidth closable options={AlertOption.errorAlert()} {onclose} />
      </div>
    {/if}
    {@render alertSlot?.()}
    {@render children?.()}
  </GridView>
</div>

<style>
  .caqh-merge-review-container {
    background-color: var(--grey-bg);
    min-width: 100%;
    height: 100%;
    padding: 24px 24px 0;
    overflow: auto;
  }

  :global(.caqh-merge-review-container .comp-grid-view) {
    height: unset;
  }
  .caqh-merge-review-container .error {
    width: 100%;
    grid-column: 1 / span 12;
    margin-top: 16px;
    margin-bottom: 16px;
  }
</style>
